import React, { Component } from "react";
import { FaDownload } from "react-icons/fa";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import MetaTags from "react-meta-tags";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import { Link } from "react-router-dom";
import Tooltip from "@material-ui/core/Tooltip";
import Select from "react-select";
import { getcyclelist } from "store/cycle/actions";
import { updatePayment } from "store/Payment/actions";
import { getdistrictlist } from "store/participantdistrict/actions";
import { getprovincelist } from "store/participantprovince/actions";
import { getbanklist } from "store/banks/actions";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  Input,
  Button,
} from "reactstrap";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator";
import filterFactory from "react-bootstrap-table2-filter";
import Breadcrumbs from "components/Common/Breadcrumb";
import { getParticipantPayment, confirmpayment } from "store/Payment/actions";
import "assets/scss/table.scss";
import { Formik, Field, Form, ErrorMessage } from "formik";
import ListProvince from "store/participantprovince/reducers";

class ParticipantPayments extends Component {
  // =======================
  // DATE HELPERS
  // =======================
  formatMonthLabel = (date) => {
    if (!date || isNaN(date)) return "";
    const month = date
      .toLocaleString("default", { month: "short" })
      .toUpperCase();
    const year = date.getFullYear().toString().slice(-2);
    return `${month}-${year}`;
  };

  parseDate = (dateStr) => {
    if (!dateStr) return null;

    // if already in ISO format YY-MM-DD
    if (dateStr.includes("-") && dateStr.length >= 10) {
      const parts = dateStr.split("-");

      // YY-MM-DD
      if (parts[0].length === 4) {
        const d = new Date(dateStr);
        return isNaN(d) ? null : d;
      }

      // DD-MM-YY
      if (parts[2].length === 4) {
        const d = new Date(parts[2], parts[1] - 1, parts[0]);
        return isNaN(d) ? null : d;
      }
    }

    // DD/MM/YY
    if (dateStr.includes("/")) {
      const parts = dateStr.split("/");
      if (parts[2].length === 4) {
        const d = new Date(parts[2], parts[1] - 1, parts[0]);
        return isNaN(d) ? null : d;
      }
    }

    const fallback = new Date(dateStr);
    return isNaN(fallback) ? null : fallback;
  };

  // =======================
  // MONTH TOTALS
  // =======================
  getMonthTotal = (month, data) => {
    let total = 0;

    data.forEach((row) => {
      (row.payments || []).forEach((p) => {
        const pDate = this.parseDate(p.payment_received_date || p.paydate);

        if (!pDate || isNaN(pDate)) return;

        if (this.formatMonthLabel(pDate) === month) {
          total += parseFloat(p.price) || 0;
        }
      });
    });

    return total;
  };

  getMonthReconciledTotal = (month, data) => {
    let total = 0;
    data.forEach((row) => {
      (row.payments || []).forEach((p) => {
        const pDate = this.parseDate(p.resolvedDate);
        if (!pDate || isNaN(pDate)) return;
        if (this.formatMonthLabel(pDate) !== month) return;

        const isVerified =
          p.payment_reconcile_status === "Verified" ||
          p.reconcileStatus === "Verified";

        const { csrFilter, districtFilter, provinceFilter } = this.state;
        if (
          csrFilter &&
          csrFilter !== "All" &&
          !p.receivedby?.toLowerCase().includes(csrFilter.toLowerCase())
        )
          return;
        if (
          districtFilter &&
          districtFilter !== "All" &&
          p.district?.toLowerCase() !== districtFilter.toLowerCase()
        )
          return;
        if (
          provinceFilter &&
          provinceFilter !== "All" &&
          p.province?.toLowerCase() !== provinceFilter.toLowerCase()
        )
          return;

        if (isVerified) total += parseFloat(p.price) || 0;
      });
    });
    return total;
  };

  getMonthNonReconciledTotal = (month, data) => {
    let total = 0;
    data.forEach((row) => {
      (row.payments || []).forEach((p) => {
        const pDate = this.parseDate(p.resolvedDate);
        if (!pDate || isNaN(pDate)) return;
        if (this.formatMonthLabel(pDate) !== month) return;

        const isVerified =
          p.payment_reconcile_status === "Verified" ||
          p.reconcileStatus === "Verified";

        const { csrFilter, districtFilter, provinceFilter } = this.state;
        if (
          csrFilter &&
          csrFilter !== "All" &&
          !p.receivedby?.toLowerCase().includes(csrFilter.toLowerCase())
        )
          return;
        if (
          districtFilter &&
          districtFilter !== "All" &&
          p.district?.toLowerCase() !== districtFilter.toLowerCase()
        )
          return;
        if (
          provinceFilter &&
          provinceFilter !== "All" &&
          p.province?.toLowerCase() !== provinceFilter.toLowerCase()
        )
          return;

        if (!isVerified) total += parseFloat(p.price) || 0;
      });
    });
    return total;
  };

  // =======================
  // CSR BASED ON DISTRICT
  // =======================
  getCSRBasedOnDistrict = () => {
    const { GetPayment, districtFilter } = this.state;

    const csrSet = new Set();

    GetPayment.forEach((entry) => {
      (entry.payments || []).forEach((p) => {
        const districtMatch =
          !districtFilter ||
          districtFilter === "All" ||
          districtFilter === "Select"
            ? true
            : p.district?.toLowerCase() === districtFilter.toLowerCase();

        if (districtMatch && p.receivedby) {
          csrSet.add(p.receivedby);
        }
      });
    });

    return Array.from(csrSet).map((csr) => ({
      value: csr,
      label: csr,
    }));
  };

  // getDistrictBasedOnCSR = () => {
  //   const { GetPayment, csrFilter } = this.state;

  //   const districtSet = new Set();

  //   GetPayment.forEach(entry => {
  //     (entry.payments || []).forEach(p => {
  //       const csrMatch =
  //         !csrFilter || csrFilter === "All" || csrFilter === "Select"
  //           ? true
  //           : p.receivedby?.toLowerCase() === csrFilter.toLowerCase();

  //       if (csrMatch && p.district) {
  //         districtSet.add(p.district);
  //       }
  //     });
  //   });

  //   return Array.from(districtSet).map(d => ({
  //     value: d,
  //     label: d,
  //   }));
  // };

  getDistrictBasedOnProvinceAndCSR = () => {
    const { GetPayment, provinceFilter, csrFilter } = this.state;

    const districtSet = new Set();

    GetPayment.forEach((entry) => {
      (entry.payments || []).forEach((p) => {
        const provinceMatch =
          !provinceFilter ||
          provinceFilter === "All" ||
          provinceFilter === "Select"
            ? true
            : p.province?.toLowerCase() === provinceFilter.toLowerCase();

        const csrMatch =
          !csrFilter || csrFilter === "All" || csrFilter === "Select"
            ? true
            : p.receivedby?.toLowerCase() === csrFilter.toLowerCase();

        if (provinceMatch && csrMatch && p.district) {
          districtSet.add(p.district);
        }
      });
    });

    return Array.from(districtSet).map((d) => ({
      value: d,
      label: d,
    }));
  };

  // =======================
  // MONTHS BETWEEN
  // =======================
  getMonthsBetween = (start, end) => {
    const startDate = new Date(start);
    const endDate = new Date(end);

    const months = [];
    let current = new Date(startDate.getFullYear(), startDate.getMonth(), 1);
    const last = new Date(endDate.getFullYear(), endDate.getMonth(), 1);

    while (current <= last) {
      months.push(this.formatMonthLabel(current));
      current.setMonth(current.getMonth() + 1);
    }

    return months;
  };

  constructor(props) {
    super(props);
    this.state = {
      nameFilter: "",
      idFilter: "",
      districtFilter: "",
      csrFilter: "",
      provinceFilter: "",
      amountFilter: "",
      discountFilter: "",
      organization_name: "",
      reconcileDate: "",
      activeRowId: null,
      paymentConfirmState: {},
      CycleList: [],
      ListDistrict: [],
      ListProvince: [],
      dateFilter: "",
      paymentmodeFilter: "",
      paymentreceivedFilter: "",
      selectedCheckboxes: {},
      tableKey: 0,
      ListBank: [],
      GetPayment: [],
      selectedBankAccount: null,
      selectedBankName: "",
      feedbackMessage: "",
      errorMessage: "",
      paymentsettlementFilter: "",
      paymentMethodFilter: "",
      paymentStatusFilter: "",
      payment_received_date: "",
      dateTo: new Date().toISOString().split("T")[0],
      dateToActive: false,
      membershipStatusFilter: "",
      selectedRow: null,
      editModalOpen: false,
      showParticipantModal: false,
      selectedParticipantForModal: null,

      user_id: localStorage.getItem("authUser")
        ? JSON.parse(localStorage.getItem("authUser")).user_id
        : "",

      feedbackListColumns: [
        {
          dataField: "participant_name",
          text: "Participant Name",
          sort: true,
          headerStyle: { backgroundColor: "#87ceeb", textAlign: "left" },
          style: { textAlign: "left" },
          formatter: (cell, row) => (
            <span
              style={{ color: "#0d6efd", cursor: "pointer" }}
              onClick={() => this.openParticipantModal(row)}
            >
              {cell}
            </span>
          ),
          headerFormatter: (column) => (
            <div style={{ textAlign: "left" }}>
              <div>{column.text}</div>
              <div style={{ marginTop: "6px" }}>
                <input
                  type="text"
                  placeholder={column.text}
                  value={this.state.nameFilter}
                  onChange={(e) => this.handleFilterChange("nameFilter", e)}
                  className="form-control"
                  style={{
                    width: "250px",
                    height: "30px",
                    fontSize: "14px",
                    lineHeight: "30px",
                    padding: "0 10px",
                    textAlign: "center",
                  }}
                />
              </div>
            </div>
          ),
        },
      ],
    };
  }

  formatNumber = (value, options = {}) => {
    const num = Number(value);
    return !num || num === 0
      ? "-"
      : num.toLocaleString(undefined, {
          minimumFractionDigits: 0,
          maximumFractionDigits: 2,
          ...options,
        });
  };

  handleCheckboxToggle = (rowId) => {
    this.setState((prevState) => ({
      paymentConfirmState: {
        ...prevState.paymentConfirmState,
        [rowId]: {
          ...prevState.paymentConfirmState[rowId],
          checked: !prevState.paymentConfirmState[rowId]?.checked,
        },
      },
      tableKey: Date.now(),
    }));
  };

  handleSaveConfirmation = (rowId) => {
    if (!rowId) {
      console.error("❌ rowId is undefined");
      return;
    }

    this.props.confirmpayment(rowId);

    this.setState((prevState) => ({
      paymentConfirmState: {
        ...prevState.paymentConfirmState,
        [rowId]: {
          checked: false,
          confirmed: true,
        },
      },
      tableKey: Date.now(),
    }));
  };

  componentDidMount() {
    const {
      onGetBankList,
      onGetDistrictList,
      onGetParticipantpayment,
      onGetprovincelist,
    } = this.props;

    const authUser = localStorage.getItem("authUser");
    const user_id = authUser ? JSON.parse(authUser).user_id : null;

    if (!user_id) {
      console.error("User ID is missing.");
      return;
    }

    onGetParticipantpayment(user_id);
    onGetBankList(user_id);
    onGetDistrictList(user_id);
    onGetprovincelist(user_id);
  }

  getMonthColumns = () => {
    const { dateFrom, dateTo } = this.state;
    if (!dateFrom || !dateTo) return [];

    const months = this.getMonthsBetween(dateFrom, dateTo);

    return months.map((month) => {
      const filteredData = this.filterData();
      const tableData =
        filteredData.length > 0 ? filteredData : this.state.GetPayment;

      const reconciledTotal = this.getMonthReconciledTotal(month, tableData);
      const nonReconciledTotal = this.getMonthNonReconciledTotal(
        month,
        tableData,
      );

      return {
        dataField: month,
        text: month,
        sort: false,
        headerStyle: {
          textAlign: "center",
          backgroundColor: "#87ceeb",
        },
        style: {
          textAlign: "center",
        },

        headerFormatter: () => (
          <div style={{ textAlign: "center" }}>
            <div style={{ fontWeight: "bold", marginBottom: "4px" }}>
              {month}
            </div>

            <div
              style={{ fontSize: "12px", fontWeight: "bold", color: "#0000CD" }}
            >
              {reconciledTotal ? this.formatNumber(reconciledTotal) : "-"}
            </div>

            <div style={{ fontSize: "12px", fontWeight: "bold", color: "red" }}>
              {nonReconciledTotal ? this.formatNumber(nonReconciledTotal) : "-"}
            </div>
          </div>
        ),

        formatter: (cell, row) => {
          const payments = row.payments || [];
          const { csrFilter, districtFilter, provinceFilter } = this.state;

          const matchingPayments = payments.filter((p) => {
            const pDate = this.parseDate(p.resolvedDate);
            if (!pDate || isNaN(pDate)) return false;
            if (
              csrFilter &&
              csrFilter !== "All" &&
              !p.receivedby?.toLowerCase().includes(csrFilter.toLowerCase())
            )
              return false;
            if (
              districtFilter &&
              districtFilter !== "All" &&
              p.district?.toLowerCase() !== districtFilter.toLowerCase()
            )
              return false;
            if (
              provinceFilter &&
              provinceFilter !== "All" &&
              p.province?.toLowerCase() !== provinceFilter.toLowerCase()
            )
              return false;
            return this.formatMonthLabel(pDate) === month;
          });

          const total = matchingPayments.reduce(
            (sum, p) => sum + (parseFloat(p.price) || 0),
            0,
          );

          if (!total) return "-";

          const hasNonVerified = matchingPayments.some(
            (p) =>
              p.payment_reconcile_status !== "Verified" &&
              p.reconcileStatus !== "Verified",
          );

          return (
            <span
              style={{
                color: hasNonVerified ? "red" : "inherit",
                fontWeight: hasNonVerified ? "bold" : "normal",
              }}
            >
              {this.formatNumber(total)}
            </span>
          );
        },
      };
    });
  };
  componentDidUpdate(prevProps) {
    const { GetPayment, ListBank, CycleList, ListDistrict, ListProvince } =
      this.props;

    if (CycleList !== prevProps.CycleList) {
      this.setState({ CycleList });
    }

    if (ListDistrict !== prevProps.ListDistrict) {
      this.setState({ ListDistrict });
    }

    if (ListProvince !== prevProps.ListProvince) {
      this.setState({ ListProvince });
    }

    let bankMap = {};
    if (ListBank && ListBank !== prevProps.ListBank) {
      ListBank.forEach((bank) => {
        bankMap[bank.account_number] = bank.name;
      });
      this.setState({ ListBank });
    } else if (this.state.ListBank) {
      this.state.ListBank.forEach((bank) => {
        bankMap[bank.account_number] = bank.name;
      });
    }

    if (GetPayment !== prevProps.GetPayment) {
      console.log("API GetPayment Data:", GetPayment);
      const participantMap = {};
      const groupedData = [];

      GetPayment.forEach((payment) => {
        const participantId = payment.participant_id;
        if (!participantMap[participantId]) {
          participantMap[participantId] = {
            participant_id: participantId,
            participant_name: payment.participant_name,
            payments: [],
          };
          groupedData.push(participantMap[participantId]);
        }

        participantMap[participantId].payments.push({
          id: payment.id,
          district: payment.district,
          price:
            payment.part_payment_amount &&
            parseFloat(payment.part_payment_amount) > 0
              ? parseFloat(payment.part_payment_amount)
              : parseFloat(payment.price),
          priceBeforeDiscount: payment.priceBeforeDiscount,
          discountAmount: payment.discountAmount,
          paymentmethod: payment.paymentmethod,
          attachment_url: payment.attachment_url || payment.attachment,
          paydate: payment.paydate,
          province: payment.province,
          photo_url: payment.photo_url,
          membership_status: payment.membership_status,
          payment_reconcile_status: payment.payment_reconcile_status || "",
          reconcileStatus: payment.payment_reconcile_status || "",
          account_number: payment.account_number || null,
          bank_name: bankMap[payment.account_number] || "Unknown",
          comments: payment.comments,
          payment_received_date: payment.payment_received_date,
          added_by_name: payment.added_by_name || "-",
          reconciled_at: payment.reconciled_at || null,
          cycle_no: payment.cycle_no || "-",
          created_at: payment.created_at,
          receivedby: payment.receivedby,
          schemes: payment.schemes || [],
          resolvedDate: payment.payment_received_date || payment.paydate, // 👈 ADD THIS
        });
      });

      const paymentConfirmState = {};
      groupedData.forEach((row) => {
        paymentConfirmState[row.id] = {
          reconcileStatus: "",
        };
      });

      this.setState({
        GetPayment: groupedData,
        paymentConfirmState,
      });
    }
  }

  toggleEditModal = async (row, participant = null) => {
    await this.props.ongetcyclelist(this.state.user_id);

    this.setState({
      editModalOpen: true,
      selectedRow: row,
      selectedParticipant: participant || {
        name: row?.participant_name || "",
        district: row?.district || "",
        id: row?.participant || "",
      },

      // ✅ FIX: previously priceBeforeDiscount undefined
      selectedPrice: row?.priceBeforeDiscount || "",
    });
  };

  handleFilterChange = (filterName, e) => {
    const value = e.target.value;

    this.setState(
      (prevState) => ({
        [filterName]: value,
        dateToActive: filterName === "dateTo" ? true : prevState.dateToActive,
      }),
      this.checkFiltersApplied,
    );
  };

  isValidFilter = (value) => {
    return value && value !== "Select" && value !== "All";
  };

  filterData = () => {
    const {
      GetPayment,
      nameFilter = "Select",
      idFilter = "Select",
      districtFilter = "Select",
      csrFilter = "Select",
      provinceFilter = "Select",
      amountFilter = "Select",
      discountFilter = "Select",
      paymentsettlementFilter = "Select",
      paymentreceivedFilter = "Select",
      membershipStatusFilter = "Select",
      paymentMethodFilter = "Select",
      paymentStatusFilter = "Select",
      reconcileStatusFilter = "Select",
      paidamountFilter = "Select",
      dateFilter = "",
      dateFrom,
      dateTo,
      dateToActive,
    } = this.state;

    const isValidFilter = (val) =>
      val !== undefined &&
      val !== null &&
      val !== "" &&
      val !== "All" &&
      val !== "Select";

    const filters = [
      nameFilter,
      idFilter,
      provinceFilter,
      districtFilter,
      csrFilter,
      amountFilter,
      discountFilter,
      paymentsettlementFilter,
      paymentMethodFilter,
      paymentStatusFilter,
      reconcileStatusFilter,
      dateFilter,
      paymentreceivedFilter,
      membershipStatusFilter,
      dateFrom,
      dateToActive ? dateTo : "",
    ];

    const isAnyFilterApplied = filters.some((f) => f && f !== "Select");

    if (!isAnyFilterApplied) return GetPayment;

    return GetPayment.filter((entry) => {
      if (
        isValidFilter(nameFilter) &&
        !entry.participant_name
          ?.toLowerCase()
          .includes(nameFilter.toLowerCase())
      )
        return false;

      if (isValidFilter(idFilter) && !entry.id?.toString().includes(idFilter))
        return false;

      if (isValidFilter(csrFilter)) {
        const hasCSR = entry.payments?.some((p) =>
          p.receivedby?.toLowerCase().includes(csrFilter.toLowerCase()),
        );
        if (!hasCSR) return false;
      }

      if (isValidFilter(districtFilter)) {
        const hasDistrict = entry.payments?.some(
          (p) => p.district?.toLowerCase() === districtFilter.toLowerCase(),
        );
        if (!hasDistrict) return false;
      }

      if (isValidFilter(provinceFilter)) {
        const hasProvince = entry.payments?.some(
          (p) => p.province?.toLowerCase() === provinceFilter.toLowerCase(),
        );
        if (!hasProvince) return false;
      }

      if (dateFrom || dateToActive) {
        const hasDate = entry.payments?.some((p) => {
          const payDate = this.parseDate(p.payment_received_date || p.paydate);

          if (!payDate || isNaN(payDate)) return false;

          if (dateFrom && payDate < new Date(dateFrom)) return false;
          if (dateToActive && payDate > new Date(dateTo)) return false;

          return true;
        });

        if (!hasDate) return false;
      }

      if (isValidFilter(discountFilter)) {
        const hasDiscount = entry.payments?.some((p) =>
          String(p.discountAmount || "").includes(discountFilter),
        );
        if (!hasDiscount) return false;
      }

      if (isValidFilter(amountFilter)) {
        const hasAmount = entry.payments?.some((p) =>
          String(p.priceBeforeDiscount || "").includes(amountFilter),
        );
        if (!hasAmount) return false;
      }

      return true;
    });
  };

  checkFiltersApplied = () => {
    const {
      nameFilter,
      idFilter,
      districtFilter,
      csrFilter,
      provinceFilter,
      amountFilter,
      discountFilter,
      paymentsettlementFilter,
      paymentMethodFilter,
      paymentStatusFilter,
      dateFilter,
      paymentreceivedFilter,
      membershipStatusFilter,
      dateFrom,
      dateToActive,
    } = this.state;

    const filters = [
      nameFilter,
      idFilter,
      districtFilter,
      provinceFilter,
      csrFilter,
      amountFilter,
      discountFilter,
      paymentsettlementFilter,
      paymentMethodFilter,
      paymentStatusFilter,
      dateFilter,
      paymentreceivedFilter,
      membershipStatusFilter,
      dateFrom,
      dateToActive ? "active" : "",
    ];

    const anyFilterSelected = filters.some((f) => f && f.trim() !== "");

    this.setState({ filtersApplied: anyFilterSelected });
  };

  getMatchingPaymentSummary = () => {
    const { GetPayment, districtFilter, csrFilter } = this.state;

    if (
      !districtFilter ||
      districtFilter === "All" ||
      !csrFilter ||
      csrFilter === "All"
    ) {
      return { count: 0, amount: 0 };
    }

    let count = 0;
    let amount = 0;

    GetPayment.forEach((entry) => {
      (entry.payments || []).forEach((p) => {
        const districtMatch =
          p.district?.toLowerCase() === districtFilter.toLowerCase();

        const csrMatch =
          p.receivedby?.toLowerCase() === csrFilter.toLowerCase();

        if (districtMatch && csrMatch) {
          count++;
          amount += parseFloat(p.price) || 0;
        }
      });
    });

    return { count, amount };
  };

  getDistrictOptionsFromPayments = () => {
    const { GetPayment } = this.state;

    const districtSet = new Set();

    GetPayment.forEach((entry) => {
      (entry.payments || []).forEach((p) => {
        if (p.district) {
          districtSet.add(p.district);
        }
      });
    });

    return Array.from(districtSet).map((d) => ({
      value: d,
      label: d,
    }));
  };

  openParticipantModal = (row) => {
    this.setState({
      showParticipantModal: true,
      selectedParticipantForModal: row,
    });
  };

  closeParticipantModal = () => {
    this.setState({
      showParticipantModal: false,
      selectedParticipantForModal: null,
    });
  };

  render() {
    const { GetPayment } = this.state;
    const monthColumns = this.getMonthColumns();
    const { ListProvince } = this.state;
    const defaultSorted = [{ dataField: "participant_id", order: "desc" }];

    const filteredData = this.filterData();
    const tableData = filteredData.length > 0 ? filteredData : GetPayment;

    let summaryMessage = null;
    const { csrFilter, districtFilter } = this.state;

    if (GetPayment.length > 0) {
      let filteredPayments = [];

      const { dateFrom, dateTo, dateToActive, provinceFilter } = this.state;

      // Add this BEFORE the forEach loop (after destructuring dateFrom, dateTo, dateToActive, provinceFilter):
      const activeMonths =
        dateFrom && dateTo ? this.getMonthsBetween(dateFrom, dateTo) : [];

      GetPayment.forEach((entry) => {
        (entry.payments || []).forEach((p) => {
          const csrMatch =
            !csrFilter || csrFilter === "All"
              ? true
              : p.receivedby?.toLowerCase() === csrFilter.toLowerCase();

          const districtMatch =
            !districtFilter || districtFilter === "All"
              ? true
              : p.district?.toLowerCase() === districtFilter.toLowerCase();

          const provinceMatch =
            !provinceFilter || provinceFilter === "All"
              ? true
              : p.province?.toLowerCase() === provinceFilter.toLowerCase();

          let dateMatch = true;
          const payDate = this.parseDate(p.payment_received_date || p.paydate);

          if (activeMonths.length > 0) {
            // Only count payments whose month falls within the displayed columns
            if (!payDate || isNaN(payDate)) {
              dateMatch = false;
            } else {
              const payMonthLabel = this.formatMonthLabel(payDate);
              dateMatch = activeMonths.includes(payMonthLabel);
            }
          } else if (dateFrom || dateToActive) {
            if (!payDate || isNaN(payDate)) {
              dateMatch = false;
            } else {
              if (dateFrom && payDate < new Date(dateFrom)) dateMatch = false;
              if (dateToActive && dateTo && payDate > new Date(dateTo))
                dateMatch = false;
            }
          }

          if (csrMatch && districtMatch && provinceMatch && dateMatch)
            filteredPayments.push(p);
        });
      });

      if (filteredPayments.length > 0) {
        // ✅ Reconciled payments (verified)
        const reconciledPayments = filteredPayments.filter(
          (p) =>
            p.payment_reconcile_status === "Verified" ||
            p.reconcileStatus === "Verified",
        );
        const reconciledCount = reconciledPayments.length;
        const reconciledAmount = reconciledPayments.reduce(
          (sum, p) => sum + (parseFloat(p.price) || 0),
          0,
        );

        const nonReconciledPayments = filteredPayments.filter(
          (p) =>
            p.payment_reconcile_status !== "Verified" &&
            p.reconcileStatus !== "Verified",
        );
        const nonReconciledCount = nonReconciledPayments.length;
        const nonReconciledAmount = nonReconciledPayments.reduce(
          (sum, p) => sum + (parseFloat(p.price) || 0),
          0,
        );

        summaryMessage = (
          <div
            style={{ fontSize: "13px", lineHeight: "2", whiteSpace: "nowrap" }}
          >
            <strong>
              {csrFilter || "All CSR"} in {districtFilter || "All Districts"}
            </strong>
            <br />
            <span>
              Total Reconcile Payments: <strong>{reconciledCount}</strong>
              &nbsp;&nbsp;|&nbsp;&nbsp; Total Non-Reconcile Payments:{" "}
              <strong style={{ color: "red" }}>{nonReconciledCount}</strong>
            </span>
            <br />
            <span>
              Total Reconcile Amount:{" "}
              <strong>{this.formatNumber(reconciledAmount)}</strong>
              &nbsp;&nbsp;|&nbsp;&nbsp; Total Non-Reconcile Amount:{" "}
              <strong style={{ color: "red" }}>
                {this.formatNumber(nonReconciledAmount)}
              </strong>
            </span>
          </div>
        );
      } else {
        summaryMessage = (
          <strong style={{ color: "red" }}>
            {csrFilter || "All CSR"} has <u>no payments</u> in{" "}
            {districtFilter || "All Districts"}.
          </strong>
        );
      }
    }

    const participantColumn = this.state.feedbackListColumns.find(
      (c) => c.dataField === "participant_name",
    );

    const allColumns = participantColumn
      ? [participantColumn, ...monthColumns]
      : [...monthColumns];

    const pageOptions = {
      sizePerPage: tableData.length || 1000,
      totalSize: tableData.length,
      hideSizePerPage: true,
      hidePageListOnlyOnePage: true,
    };

    const districtOptions = this.getDistrictBasedOnProvinceAndCSR();

    return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>FINANACE REPORT | NHS NEQAS</title>
          </MetaTags>

          <Container fluid>
            <Breadcrumbs title="Labs" breadcrumbItem="Finance Report" />
            <p style={{ fontSize: "14px", color: "#000", marginTop: "0px" }}>
              <b>Note:</b>{" "}
              <span style={{ color: "black" }}>
                <b>Reconciled</b>
              </span>{" "}
              payments are shown in Black and
              <span style={{ color: "black" }}>
                <b> Non-Reconciled</b>
              </span>{" "}
              payments are shown in <b style={{ color: "red" }}>Red</b>
            </p>

            <Row className="justify-content-center align-item-center">
              <Col lg="12">
                <Card>
                  <CardBody>
                    <Modal
                      isOpen={this.state.showParticipantModal}
                      toggle={this.closeParticipantModal}
                      centered
                      size="md"
                    >
                      <ModalHeader toggle={this.closeParticipantModal}>
                        <span style={{ fontWeight: 600, fontSize: "16px" }}>
                          {this.state.selectedParticipantForModal
                            ?.participant_name || "Participant Details"}
                        </span>
                      </ModalHeader>

                      <ModalBody>
                        {(() => {
                          const payments =
                            this.state.selectedParticipantForModal?.payments ||
                            [];
                          const allSchemes = [];
                          const seenKeys = new Set();

                          payments.forEach((p) => {
                            (p.schemes || []).forEach((scheme) => {
                              const key = `${scheme.scheme_id}-${scheme.cycle_id}`;
                              if (!seenKeys.has(key)) {
                                seenKeys.add(key);
                                allSchemes.push(scheme);
                              }
                            });
                          });

                          return (
                            <table className="table table-bordered table-sm text-center">
                              <thead className="table-light">
                                <tr>
                                  <th>Scheme Name</th>
                                  <th>Cycle No</th>
                                </tr>
                              </thead>
                              <tbody>
                                {allSchemes.length > 0 ? (
                                  allSchemes.map((scheme, index) => (
                                    <tr key={index}>
                                      <td>{scheme.scheme_name || "-"}</td>
                                      <td>{scheme.cycle_no || "-"}</td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td
                                      colSpan="3"
                                      className="text-muted text-center"
                                    >
                                      No schemes found
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          );
                        })()}
                      </ModalBody>
                    </Modal>
                    <PaginationProvider
                      pagination={paginationFactory(pageOptions)}
                      keyField="participant_id"
                      columns={allColumns}
                      data={tableData}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <ToolkitProvider
                          keyField="participant_id"
                          columns={allColumns}
                          data={tableData}
                          search
                        >
                          {(toolkitprops) => (
                            <React.Fragment>
                              <Row>
                                <Col md={3}>
                                  <Label for="dateFrom">
                                    Payment Start Date
                                  </Label>
                                  <input
                                    type="date"
                                    id="dateFrom"
                                    className="form-control"
                                    value={this.state.dateFrom}
                                    onChange={(e) =>
                                      this.setState(
                                        { dateFrom: e.target.value },
                                        this.checkFiltersApplied,
                                      )
                                    }
                                  />
                                </Col>

                                <Col md={3}>
                                  <Label for="dateTo">Payment End Date</Label>
                                  <input
                                    type="date"
                                    id="dateTo"
                                    className="form-control"
                                    value={this.state.dateTo}
                                    onChange={(e) =>
                                      this.setState(
                                        {
                                          dateTo: e.target.value,
                                          dateToActive: true,
                                        },
                                        this.checkFiltersApplied,
                                      )
                                    }
                                  />
                                </Col>

                                <Col md={4}>
                                  <Label for="provinceFilter">Province</Label>
                                  <Select
                                    id="provinceFilter"
                                    options={[
                                      { value: "All", label: "All Province" },
                                      ...ListProvince.map((province) => ({
                                        value: province.name,
                                        label: province.name,
                                      })),
                                    ]}
                                    value={
                                      this.state.provinceFilter
                                        ? {
                                            value: this.state.provinceFilter,
                                            label: this.state.provinceFilter,
                                          }
                                        : null
                                    }
                                    onChange={(selected) =>
                                      this.setState(
                                        {
                                          provinceFilter: selected?.value || "",
                                          districtFilter: "", // reset district
                                        },
                                        this.checkFiltersApplied,
                                      )
                                    }
                                    isClearable
                                  />
                                </Col>
                              </Row>

                              <Row className="mb-3">
                                <Col md={4}>
                                  <Label for="districtFilter">District</Label>
                                  <Select
                                    id="districtFilter"
                                    options={[
                                      { value: "All", label: "All Districts" },
                                      ...districtOptions,
                                    ]}
                                    value={
                                      this.state.districtFilter
                                        ? {
                                            value: this.state.districtFilter,
                                            label: this.state.districtFilter,
                                          }
                                        : null
                                    }
                                    onChange={(selected) =>
                                      this.setState(
                                        {
                                          districtFilter: selected?.value || "",
                                        },
                                        this.checkFiltersApplied,
                                      )
                                    }
                                    isClearable
                                  />
                                </Col>

                                <Col md={4}>
                                  <Label for="csrFilter">CSR Name</Label>
                                  <Select
                                    id="csrFilter"
                                    options={[
                                      { value: "All", label: "All CSR" },
                                      ...this.getCSRBasedOnDistrict(),
                                    ]}
                                    value={
                                      this.state.csrFilter
                                        ? {
                                            value: this.state.csrFilter,
                                            label: this.state.csrFilter,
                                          }
                                        : null
                                    }
                                    onChange={(selected) =>
                                      this.handleFilterChange("csrFilter", {
                                        target: {
                                          value: selected?.value || "",
                                        },
                                      })
                                    }
                                    isClearable
                                  />
                                </Col>

                                <Col md={5} style={{ marginTop: "20px" }}>
                                  {summaryMessage}
                                </Col>
                              </Row>

                              <Row className="mb-4">
                                <Col xl="12">
                                  <div className="table-responsive">
                                    <BootstrapTable
                                      key={this.state.tableKey}
                                      {...toolkitprops.baseProps}
                                      {...paginationTableProps}
                                      defaultSorted={defaultSorted}
                                      classes={"table align-middle"}
                                      bordered={false}
                                      striped={false}
                                      headerWrapperClasses={
                                        "table-header-sky-blue"
                                      }
                                      responsive
                                      ref={this.node}
                                      filter={filterFactory()}
                                    />
                                  </div>
                                </Col>
                              </Row>

                              <Row className="align-items-md-center mt-30">
                                <Col className="pagination pagination-rounded justify-content-end mb-2">
                                  <PaginationListStandalone
                                    {...paginationProps}
                                  />
                                </Col>
                              </Row>
                            </React.Fragment>
                          )}
                        </ToolkitProvider>
                      )}
                    </PaginationProvider>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

ParticipantPayments.propTypes = {
  GetPayment: PropTypes.array,
  onGetParticipantpayment: PropTypes.func,
  CycleList: PropTypes.array,
  confirmpayment: PropTypes.func,
  dispatch: PropTypes.func.isRequired,
  ongetcyclelist: PropTypes.func,
  match: PropTypes.object,
  onupdatePayment: PropTypes.func,
  ListDistrict: PropTypes.array,
  ListProvince: PropTypes.array,
  onGetDistrictList: PropTypes.func,
  onGetprovincelist: PropTypes.func,
  ListBank: PropTypes.array,
  onGetBankList: PropTypes.func,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

const mapStateToProps = (state) => {
  const cycleList = state.CycleList?.CycleList || [];
  const ListDistrict = state.ListDistrict?.ListDistrict || [];
  const ListProvince = state.ListProvince?.ListProvince || [];

  return {
    userID: state.Account?.userID || null,
    CycleList: cycleList,
    PaymentSchemeList: state.PaymentScheme?.PaymentSchemeList || [],
    GetPayment: state.AddPayment?.GetPayment ?? [],
    ListBank: state.banks.ListBank,
    ListDistrict,
    ListProvince,
  };
};

const mapDispatchToProps = (dispatch) => ({
  onGetParticipantpayment: (id) => dispatch(getParticipantPayment(id)),
  ongetcyclelist: (id) => dispatch(getcyclelist(id)),
  onupdatePayment: (payload) => dispatch(updatePayment(payload)),
  onGetDistrictList: (id) => dispatch(getdistrictlist(id)),
  onGetprovincelist: (id) => dispatch(getprovincelist(id)),
  confirmpayment: (id) => dispatch(confirmpayment(id)),
  onGetBankList: (id) => dispatch(getbanklist(id)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ParticipantPayments);
